const Text = ({ rowItem }) => {
  return <p className="text-sm text-primary-navy-400">{rowItem || '-'}</p>;
};

export default Text;
